import { Module } from 'vuex'

import { makeBaseList } from '../models'
import { RootState } from '../state'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { MenuState } from './state'

const namespaced = true

const state: MenuState = {
  itemGroups: {
    ...makeBaseList(),
    query: {},
    items: {},
    optionGroups: {}
  },
  items: {
    elements: [],
    portions: {}
  },
  optionGroups: {
    elements: [],
    options: {}
  },
  options: {
    elements: []
  },
  portions: {
    elements: []
  }
}

const module: Module<MenuState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}

export default module
